<template>
<div class="similar_anime_block watching_anime_block mb-15 only-for-swiper-main-page">
  

    <div class="nova-swiper-container" v-if="isMobile">
        <div class="nova-swiper-wrapper">
            <div v-for="anime in anime_list" :key="anime.shikimori_id" class="my-swiper-slider">
              <router-link :to="'/' + anime.shikimori_id" :title="anime.title">
                <!-- <img :src="anime.material_data ? anime.material_data.poster_url : '#'"/> -->
                <div class="image" :style="{'background-image': 'url(' + (anime.material_data ? anime.material_data.poster_url.replace('.me', '.one') : '@/assets/404_not_found.png') + ')'}"></div>
                <div class="rating_status"> 
                  <span class="rating">
                    <img src="@/assets/icons/shikimori_icon.svg">  
                    {{ anime.material_data ? anime.material_data.shikimori_rating  : "0.0" }}
                  </span>
                  <div class="status">
                    <span :class="anime.material_data 
                    ? (anime.material_data.anime_status === 'ongoing' 
                       ? 'blue' 
                       : (anime.material_data.anime_status === 'anons' ? 'red' : 'green')) 
                    : ''">{{ getRuStatus(anime.material_data ? anime.material_data.anime_status || '' : '') }}</span>
                  </div>
                </div>
              </router-link>
              <p style="font-family: 'Montserrat',sans-serif;" class="three-dots truncate" @click="truncate" :title="anime.title">{{ anime.title }}</p>
            </div>
        </div>
       
        <div class="swiper-pagination"></div>
    </div>

   
    <div class="swiper-container" v-if="!isMobile">
        <div class="swiper-wrapper">
            <div v-for="anime in anime_list" :key="anime.shikimori_id" class="swiper-slide">
              <router-link :to="'/' + anime.shikimori_id" :title="anime.title">
                <!-- <img :src="anime.material_data ? anime.material_data.poster_url : '#'"/> -->
                <div class="image" :style="{'background-image': 'url(' + (anime.material_data ? anime.material_data.poster_url.replace('.me', '.one') : 'https://anione.fun/404_not_found.png') + ')'}"></div>
                <div class="rating_status">
                  <span class="rating">
                    <img src="@/assets/icons/shikimori_icon.svg">  
                    {{ anime.material_data ? anime.material_data.shikimori_rating  : "0.0" }}
                  </span>
                  <div class="status">
                    <span :class="anime.material_data 
                    ? (anime.material_data.anime_status === 'ongoing' 
                       ? 'blue' 
                       : (anime.material_data.anime_status === 'anons' ? 'red' : 'green')) 
                    : ''">{{ getRuStatus(anime.material_data ? anime.material_data.anime_status || '' : '') }}</span>
                  </div>
                </div>
                
              </router-link>
              <p style="font-family: 'Montserrat';" class="three-dots truncate" @click="truncate" :title="anime.title">{{ anime.title }}</p>
            </div>
        </div>
    
        
    </div>
</div>   
</template>



<script>
import axios from 'axios';
import Swiper from '@/shared/lib/third-parties/swiper.js'

export default {
  props: {
    props_url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      originUrl: window.location.origin,
      title: "",
      anime_list: [],
      isMobile: false
    };
  },
  created(){
   
    this.getWatchingAnime();
  },
  updated() {
    if(this.isMobileFunc()){
      // this.setWidthOfSimilar();
      // document.querySelector('.nova-swiper-wrapper').style.display = 'flex';
      // document.querySelector('.nova-swiper-wrapper').style.flexWrap = 'nowrap';
      // display: flex;
    ;
    }
  },
  mounted(){
    // document.querySelector('.nova-swiper-wrapper').style.display = 'flex';
    // document.querySelector('.nova-swiper-wrapper').style.flexWrap = 'nowrap';
  },
  methods: {
    truncate: function(e) {
      console.log(e.target.style.display);
      var p = e.target;
      this.isExpanded = !this.isExpanded;
      if (e.target.style.display === '-webkit-box' || e.target.style.display === '') {
        p.style.display = 'block';
      } else {
        p.style.display = '-webkit-box';
      }
    },
    getWatchingAnime: function(){
        let url = `https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial`;

        axios
      .get(this.props_url)
      .then(response => {
        // console.log(this.removeDuplicates(response.data.results));
        this.anime_list = this.removeDuplicates(response.data.results);
        console.log(this.anime_list)
        // console.log(this.anime_list)
        if(this.isMobileFunc()){
          this.isMobile = true;
          // this.setWidthOfSimilar();
          // document.querySelector('.nova-swiper-wrapper').style.display = 'flex';
          // document.querySelector('.nova-swiper-wrapper').style.flexWrap = 'nowrap';
        }else{
          this.isMobile = false;
          setTimeout(function(){
           new Swiper('.swiper-container', {
            slidesPerView: "auto",
            direction: "horizontal",
            touchRatio: 1.0,
            freeMode: true, 
            grabCursor: true
             
          });
         },20);
        }
      })
      .catch(error => {
        console.log(error);
      });
    },
    setWidthOfSimilar: function(){
      let swiperWrapper = document.querySelector('.' + this.props_class_wrapper);
      let widthOfSimilarImages = 0;
      console.log(this.anime_list.length)
      for(let i = 0;i < this.anime_list.length;i++){
          widthOfSimilarImages += (175 + 30);
      }
      
      swiperWrapper.style.width = widthOfSimilarImages + 'px';
      console.log(swiperWrapper.style.width)
      return widthOfSimilarImages;
    },
    isMobileFunc: function() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
         return true
      } else {
         return false
      }
    },
    //CLEAN FUNCTION(Интересно работает)
    //Описание: Удаляем дубликаты из массива и возвращаем массив без дублей
    //@param {array} берет массив
    //@return {array} возвращает новый массив без дубликатов
    removeDuplicates: function(arr) {
      const result = [];
      const titles = new Set(); // Создаем пустой Set для хранения уникальных titles
      // Итерируемся по массиву и добавляем объект в результирующий массив, только если его title не был добавлен ранее в Set
      arr.forEach(obj => {
        if (!titles.has(obj.shikimori_id)) {
          result.push(obj);
          titles.add(obj.shikimori_id);
        }
      });
      return result;
    },
    getRuStatus: function(status){
      switch (status) {
        case 'released':
          return 'Вышел';
        case 'ongoing':
          return 'Выходит';
        case 'anons':
          return 'Анонс';
        default:
          return status;
      }
    },
  }
  
};
</script>

<style>
.blue{
  background-color: #0d6efd;
  padding: 3px 5px;
  border-radius: 4px;
}

.red{
  background-color: red;
  padding: 3px 5px;
  border-radius: 4px;
}

.green{
  background-color: green;
  padding: 3px 5px;
  border-radius: 4px;
}

.three-dots.truncate{
  background-color: #000000a3;
  border-radius: 7px;
}


.nova-swiper-container::-webkit-scrollbar {
  display: none !important;           
}

.movie-swiper-container::-webkit-scrollbar {
  display: none !important;           
}

.watching_anime_block {
  width: 100%;
}

.watching_anime_block h3{
  text-align: left;
  font-size: 20px;
}


.watching_anime_block .swiper-container {
  margin: 0 !important;
}

.similar_anime_block .rating img{
  width: 14px;
  height: 14px;
  transform: translateY(3px);
}

.similar_anime_block .image{
  width: 100%;
  height: 240px;
  border-radius: 8px;
  background-size: cover;
}

.similar_anime_block .rating_status{
  display: flex;
  position: relative;
  bottom: 30px;
  left: 8px;
}

.similar_anime_block .rating{
  /* position: absolute; */
  background: #3e3e3e;
  border-radius: 5px;
  padding: 2px 8px;
  left: 6px;
  bottom: 82px;
  font-size: 13px;
}


.similar_anime_block .status{
  font-size: 13px;
  margin-top: 3px;
  margin-left: 8px;
}





.nova-swiper-wrapper .rating img, .movie-swiper-wrapper .rating img{
  width: 14px;
  height: 14px;
  transform: translateY(3px);
}

.nova-swiper-wrapper:nth-of-type(1), .movie-swiper-wrapper:nth-of-type(1), .serial-swiper-wrapper:nth-of-type(1), .ova-swiper-wrapper:nth-of-type(1), .ona-swiper-wrapper:nth-of-type(1) {
    margin-left: 20px;
}


.similar_anime_block.watching_anime_block.mb-15 .three-dots{
  margin-top: -10px !important;
}

.only-for-swiper-main-page{
  height: 290px;
}

p.truncate {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}


@media only screen and (max-width: 600px) {
  .watching_anime_block h3{
    margin-bottom: 0;
  }

  .watching_anime_block h3{
    padding-left: 20px;
  }

  .nova-swiper-wrapper .rating, .movie-swiper-wrapper .rating, .serial-swiper-wrapper .rating, .ova-swiper-wrapper .rating, .ona-swiper-wrapper .rating{
    background: #3e3e3e;
    border-radius: 5px;
    padding: 2px 8px;
    font-size: 13px;
  }

  .nova-swiper-wrapper{
    display: flex;
    flex-wrap: nowrap;
  }
  
}


@media only screen and (max-width: 992px) {
  .nova-swiper-container::-webkit-scrollbar,.movie-swiper-container::-webkit-scrollbar,.serial-swiper-container::-webkit-scrollbar, .ova-swiper-container::-webkit-scrollbar, .ona-swiper-container::-webkit-scrollbar {
    height: 4px;            
  }

  .nova-swiper-container,.movie-swiper-container,.serial-swiper-container, .ova-swiper-container, .ona-swiper-container{
    overflow: auto;
    margin: 0;
    transform: rotateX(180deg);
  }

  .nova-swiper-wrapper,.movie-swiper-wrapper,.serial-swiper-wrapper, .ova-swiper-wrapper, .ona-swiper-wrapper{
    border-color: transparent;
    transform: rotateX(180deg);
  }
}
</style>